import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import * as url from "../url_helper";
import accessToken from "../jwt-token-access/accessToken";
import {API_HELPER} from '../ApiHelper';
import { API_WEB_URLS } from "../../constants/constAPI";
// let users = [
//   {
//     uid: 1,
//     username: "admin",
//     role: "admin",
//     password: "123456",
//     email: "admin@themesbrand.com",
//   },
// ];

const fakeBackend = () => {
  // This sets the mock adapter on the default instance
  const mock = new MockAdapter(axios, { onNoMatch: "passthrough" });

  mock.onPost(url.POST_FAKE_REGISTER).reply(async (config) => {
    try {
      const regData = JSON.parse(config["data"]);
      const formData = new FormData();
      formData.append("FirmName", regData.firmName || regData.username || "");
      formData.append("OwnerName", regData.ownerName || regData.username || "");
      formData.append("MobileNo", regData.mobileNo || regData.phone || regData.username || "");
      formData.append("Email", regData.email || "");
      formData.append("Password", regData.password || "");
      formData.append("City", regData.city || "");
      formData.append("State", regData.state || "");
      formData.append("GSTNo", regData.gstNo || "");

      const res = await API_HELPER.apiPOST_Multipart(API_WEB_URLS.BASE + "FirmRegistration", formData);
      if (res && (res.success || res.status === 200)) {
        return [200, res.data || res];
      } else {
        const errorMsg = res?.message || res?.data?.message || "Registration failed. Please review your details and try again.";
        return [400, { message: errorMsg }];
      }
    } catch (err) {
      return [400, { message: err?.message || "Registration failed" }];
    }
  });
  
  mock.onPost("/post-fake-login").reply(config => {
    const user = JSON.parse(config["data"]);
    let vformData = new FormData();
    vformData.append("UserName", user.email);
    vformData.append("UserPassword", user.password);

    let AuthUser = function() {
      return API_HELPER.apiPOST_Multipart(API_WEB_URLS.BASE + "AdminLogin", vformData).then(token => token);
    };
    
    let userToken = AuthUser();

    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        userToken.then(async function(result) {
          console.log(result?.data, "result");
          if (result?.success && result?.data?.user?.Id > 0) {
            const userData = result?.data?.user || {};
            const firmId = userData.FirmId || userData.firmId || userData.F_FirmMaster || userData.f_FirmMaster || 1;
            const firmName = userData.FirmName || userData.firmName || userData.Name || userData.name || "Default Firm";
            const ownerName = userData.OwnerName || userData.ownerName || "";
            const city = userData.City || userData.city || "";
            const state = userData.State || userData.state || "";

            let users = [
              {
                uid: userData.Id || userData.id,
                username: userData.UserName || userData.userName,
                UserType: userData.UserType || userData.userType,
                role: "admin",
                password: user.password,
                email: user.email,
                token: result?.data?.token,
                // SaaS Firm & Subscription Properties
                FirmId: firmId,
                FirmName: firmName,
                OwnerName: ownerName,
                FirmCode: userData.FirmCode || userData.firmCode || "",
                City: city,
                State: state,
                SupportContactNumber: userData.SupportContactNumber || userData.supportContactNumber || "+91 99999-99999",
                PlanName: userData.PlanName || userData.planName || "Standard",
                PlanType: userData.PlanType || userData.planType || "TRIAL",
                StartDate: userData.StartDate || userData.startDate,
                EndDate: userData.EndDate || userData.endDate,
                GraceEndDate: userData.GraceEndDate || userData.graceEndDate,
                DaysRemaining: (userData.DaysRemaining !== undefined ? userData.DaysRemaining : userData.daysRemaining !== undefined ? userData.daysRemaining : 7),
                GraceDaysRemaining: (userData.GraceDaysRemaining !== undefined ? userData.GraceDaysRemaining : userData.graceDaysRemaining !== undefined ? userData.graceDaysRemaining : 0),
                SubscriptionStatus: userData.SubscriptionStatus || userData.subscriptionStatus || 100
              },
            ];

            try {
              localStorage.setItem("firmSubscription", JSON.stringify({
                firmId: firmId,
                firmName: firmName,
                ownerName: ownerName,
                firmCode: userData.FirmCode || userData.firmCode || "",
                city: city,
                state: state,
                planName: userData.PlanName || userData.planName || "Standard",
                planType: userData.PlanType || userData.planType || "TRIAL",
                startDate: userData.StartDate || userData.startDate,
                endDate: userData.EndDate || userData.endDate,
                graceEndDate: userData.GraceEndDate || userData.graceEndDate,
                daysRemaining: (userData.DaysRemaining !== undefined ? userData.DaysRemaining : userData.daysRemaining !== undefined ? userData.daysRemaining : 7),
                graceDaysRemaining: (userData.GraceDaysRemaining !== undefined ? userData.GraceDaysRemaining : userData.graceDaysRemaining !== undefined ? userData.graceDaysRemaining : 0),
                subscriptionStatus: userData.SubscriptionStatus || userData.subscriptionStatus || 100,
                supportContactNumber: userData.SupportContactNumber || userData.supportContactNumber || "+91 99999-99999"
              }));
            } catch(e) {}

            try {
              const globalOptionsUrl = API_WEB_URLS.BASE + API_WEB_URLS.MASTER + "/0/token/GlobalOptions/Id/0";
              const res = await API_HELPER.apiGET(globalOptionsUrl, {
                Authorization: `Bearer ${result?.data?.token}`,
                "X-Firm-Id": firmId.toString(),
              });
              const rawOpts = res?.data?.dataList ?? res?.data ?? res;
              let optsArray = Array.isArray(rawOpts) ? rawOpts : (rawOpts ? [rawOpts] : []);
              optsArray.sort((a, b) => {
                if (String(a?.F_FirmMaster) === String(firmId)) return -1;
                if (String(b?.F_FirmMaster) === String(firmId)) return 1;
                return 0;
              });
              if (optsArray.length > 0 && String(optsArray[0].F_FirmMaster) === String(firmId)) {
                if (!optsArray[0].Name || optsArray[0].Name === "Shri Ram Agri Broker") {
                  optsArray[0].Name = firmName;
                }
              }
              localStorage.setItem("GlobalOptions", JSON.stringify(optsArray));
            } catch (err) {
              console.warn("GlobalOptions fetch failed:", err);
            }

            resolve([200, users[0]]);
          } else {
            // Check for specific subscription status codes
            const status = result?.status || (result?.data && result.data.status);
            const msg = result?.message || result?.data?.message;

            if (status === 201) {
              reject(["Your firm's service has been suspended by the administrator. Please contact support (+91 99999-99999)."]);
            } else if (status === 202) {
              reject(["Your subscription has expired and grace period ended. To reactivate your account, please contact support (+91 99999-99999)."]);
            } else if (msg) {
              reject([msg]);
            } else {
              reject(["Username and password are invalid. Please enter correct username and password"]);
            }
          }
        }).catch(err => {
          reject([err?.message || "Login failed. Please check credentials or contact support."]);
        });
      });
    });
  });
  // mock.onPost("/post-fake-login").reply((config) => {
  //   const user = JSON.parse(config["data"]);
  //   const validUser = users.filter(
  //     (usr) => usr.email === user.email && usr.password === user.password
  //   );
    
  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       if (validUser["length"] === 1) {
  //         resolve([200, validUser[0]]);
  //       } else {
  //         reject([
  //           "Username and password are invalid. Please enter correct username and password",
  //         ]);
  //       }
  //     });
  //   });
  // });

  mock.onPost("/fake-forget-pwd").reply((config) => {
    // User needs to check that user is eXist or not and send mail for Reset New password

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve([200, "Check you mail and reset your password."]);
      });
    });
  });

  mock.onPost("/post-jwt-register").reply((config) => {
    const user = JSON.parse(config["data"]);
    users.push(user);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve([200, user]);
      });
    });
  });

  mock.onPost("/post-jwt-login").reply((config) => {
    const user = JSON.parse(config["data"]);
    const validUser = users.filter(
      (usr) => usr.email === user.email && usr.password === user.password
    );

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (validUser["length"] === 1) {
          // You have to generate AccessToken by jwt. but this is fakeBackend so, right now its dummy
          const token = accessToken;
          const userName = user.name;

          // JWT AccessToken
          const tokenObj = { accessToken: token, username: userName }; // Token Obj
          const validUserObj = { ...validUser[0], ...tokenObj, ...user.name }; // validUser Obj

          resolve([200, validUserObj]);
        } else {
          reject([
            400,
            "Username and password are invalid. Please enter correct username and password",
          ]);
        }
      });
    });
  });

  mock.onPost("/post-jwt-profile").reply((config) => {
    const user = JSON.parse(config["data"]);

    const one = config.headers;

    let finalToken = one.Authorization;

    const validUser = users.filter((usr) => usr.uid === user.idx);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Verify Jwt token from header.Authorization
        if (finalToken === accessToken) {
          if (validUser["length"] === 1) {
            let objIndex;

            //Find index of specific object using findIndex method.
            objIndex = users.findIndex((obj) => obj.uid === user.idx);

            //Update object's name property.
            users[objIndex].username = user.username;

            // Assign a value to locastorage
            localStorage.removeItem("authUser");
            localStorage.setItem("authUser", JSON.stringify(users[objIndex]));

            resolve([200, "Profile Updated Successfully"]);
          } else {
            reject([400, "Something wrong for edit profile"]);
          }
        } else {
          reject([400, "Invalid Token !!"]);
        }
      });
    });
  });

  mock.onPost("/post-fake-profile").reply((config) => {
    const user = JSON.parse(config["data"]);
    
    const validUser = users.filter((usr) => usr.uid === user.idx);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (validUser["length"] === 1) {
          let objIndex;

          //Find index of specific object using findIndex method.
          objIndex = users.findIndex((obj) => obj.uid === user.idx);

          //Update object's name property.
          users[objIndex].username = user.username;

          // Assign a value to locastorage
          localStorage.removeItem("authUser");
          localStorage.setItem("authUser", JSON.stringify(users[objIndex]));

          resolve([200, "Profile Updated Successfully"]);
        } else {
          reject([400, "Something wrong for edit profile"]);
        }
      });
    });
  });

  mock.onPost("/jwt-forget-pwd").reply((config) => {
    // User needs to check that user is eXist or not and send mail for Reset New password

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve([200, "Check you mail and reset your password."]);
      });
    });
  });

  mock.onPost("/social-login").reply((config) => {
    const user = JSON.parse(config["data"]);

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (user && user.token) {
          // You have to generate AccessToken by jwt. but this is fakeBackend so, right now its dummy
          const token = accessToken;
          const userName = user.name;

          // JWT AccessToken
          const tokenObj = { accessToken: token, username: userName }; // Token Obj
          const validUserObj = { ...user[0], ...tokenObj, ...user.name }; // validUser Obj

          resolve([200, validUserObj]);
        } else {
          reject([
            400,
            "Username and password are invalid. Please enter correct username and password",
          ]);
        }
      });
    });
  });
};

export default fakeBackend;
